<template>
  <div class="settings-block">
    <div class="settings-block__title">
      <div class="settings-block__title-text">
        {{ t('Two-Factor Authentication') }}
      </div>
      <div class="settings-block__title-buttons">
        <ui-button
          v-if="twoFactorEnabled"
          :text="t('Disable 2FA')"
          icon="fas fa-shield-alt"
          button-style="outline-accent"
          :disabled="isMember"
          @click="disable"
        />

        <ui-button
          v-else
          :text="t('Enable 2FA')"
          icon="fas fa-shield-alt"
          button-style="outline-accent"
          :disabled="isMember"
          @click="enable"
        />
      </div>
    </div>

    <div class="second-factor__content">
      <div
        class="second-factor__status"
        :class="
          twoFactorEnabled
            ? 'second-factor__status--enabled'
            : 'second-factor__status--disabled'
        "
      >
        {{ twoFactorEnabled ? t('Enabled') : t('Disabled') }}
      </div>

      <p
        class="second-factor__description"
        v-html="
          t(
            'Two-step authentication adds an extra layer of protection to your account.<br>Whenever you sign in to our website, you\'ll need to enter both your password and also a security code from mobile phone app.',
          )
        "
      />

      <p v-if="twoFactorEnabled && isMember" class="second-factor__description">
        {{ t('The 2FA can only be disabled by the account owner.') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@/composables';
import { useStore } from '@/store';
import { $emitter } from '@/services/emitter';

const { t } = useI18n();
const store = useStore();

const twoFactorEnabled = computed(() => store.user.twoFactorEnabled);
const isMember = computed(() => store.user.isMember);

const enable = () => {
  $emitter.emit('open-dialog', { name: 'EnableSecondFactor' });
};

const disable = () => {
  $emitter.emit('open-dialog', { name: 'DisableSecondFactor' });
};
</script>

<style lang="scss" scoped>

.second-factor__content {
  color: var(--color-graphite);
  font-size: 13px;
  line-height: 1.69;
}

.second-factor__status {
  font-size: 18px;
  font-weight: normal;
  margin: 0 0 4px;
  text-transform: uppercase;
}

.second-factor__status--disabled {
  color: var(--color-red);
}

.second-factor__status--enabled {
  color: var(--color-green);
}

.second-factor__description {
  margin: 0 0 16px;
}

.second-factor__description:last-child {
  margin-bottom: 0;
}
</style>
